// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","details__unordered-list":"details__unordered-list","details__list-item":"details__list-item","details__name":"details__name","details__value":"details__value"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/Details/css/Details.styl
// module id = 1480
// module chunks = 0